import { axios } from "@Root/API";

export const deleteContactRelationship = (contactId, relationshipId) => {
  return axios.delete(`contacts/relation/${contactId}/${relationshipId}`);
};
